import { OpenModal } from 'contexts/ModalContext/ModalContext.type';

export const handlePoorStandingOrSuspended = ({
    openModal,
}: {
    openModal: OpenModal;
}) => {
    openModal.poorStandingOrSuspended();
};
